import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SignaturePad from '../components/SignaturePad';
import BloqueoElectrico from '../components/BloqueoElectrico';
import DescargoElectrico from '../components/DescargoElectrico';
import '../styles/HptScreens.css';
import Swal from 'sweetalert2';
import PTWPdfTemplate from '../components/PTWPdfTemplate'; 
import html2pdf from 'html2pdf.js';
import { useRef } from 'react';

// BackEnd de Serveless
const API_URL = process.env.REACT_APP_API_URL;

// ============================================================================
// COMPONENTE: ExpandableCard (Acordeón reutilizable)
// ============================================================================
const ExpandableCard = ({ title, icon, children, defaultOpen = false, externalOpen, onToggle }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    useEffect(() => {
        if (externalOpen !== undefined) setIsOpen(externalOpen);
    }, [externalOpen]);

    const handleToggle = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        if (onToggle) onToggle(newState); // Avisa al padre del cambio
    };

    return (
        <div className="expandable-card">
            <div className="card-header" onClick={handleToggle}>
                <span>{icon} {title}</span>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            <div className={`card-content ${isOpen ? 'open' : ''}`} style={isOpen ? { overflow: 'visible' } : {}}>
                {children}
            </div>
        </div>
    );
};

// ============================================================================
// COMPONENTE PRINCIPAL: DetailsPTWScreen
// ============================================================================
const DetailsPTWScreen = () => {
    const { id } = useParams(); // Saca el ID interno del PTW desde la URL
    const navigate = useNavigate();
    
    // --- ESTADOS PRINCIPALES ---
    const [ptw, setPtw] = useState(null);               // Objeto completo traído del servidor
    const [ptwOriginal, setPtwOriginal] = useState(null);  // Comparador de Modificacion
    const [activos, setActivos] = useState([]);         // Lista para el buscador
    const [catalogo, setCatalogo] = useState([]);       // Catálogo de seguridad
    const [seleccionados, setSeleccionados] = useState([]); // IDs de riesgos/medidas
    const [seleccionadosOriginal, setSeleccionadosOriginal] = useState([]); // Comparador de Modificacion
    const [loading, setLoading] = useState(true);       // Spinner de carga inicial
    const [usuarios, setUsuarios] = useState([]);

    // --- ESTADOS DE FIRMAS ---
    const [showSignature, setShowSignature] = useState(false); // Muestra/Oculta el pad negro
    const [renovaciones, setRenovaciones] = useState([]);      // Array para las jornadas extra
    const [renovacionesOriginal, setRenovacionesOriginal] = useState([]); // Para controlar el estado de Detenido con Renovaciones ya activas
    const [currentSignType, setCurrentSignType] = useState(null); // Guarda quién va a firmar (sección y rol)

    // --- ESTADOS DEL BUSCADOR DE ACTIVOS ---
    const [busquedaActivo, setBusquedaActivo] = useState('');
    const [mostrarDesplegable, setMostrarDesplegable] = useState(false);
    const [opcionesActivos, setOpcionesActivos] = useState([]);
    
    const [refsElecOp, setRefsElecOp] = useState([]);
    const [refsDescElecOp, setRefsDescElecOp] = useState([]);
    const [refsDescMecOp, setRefsDescMecOp] = useState([]);
    const [refsElecMan, setRefsElecMan] = useState([]);
    const [refsDescElecMan, setRefsDescElecMan] = useState([]);
    const [refsDescMecMan, setRefsDescMecMan] = useState([]);
    

    // --- REFERENCIA PARA EL PDF ---
    const pdfRef = useRef(null);

    // --- ESTADOS DEL BUSCADOR DE USUARIOS (RECURSOS PREVENTIVOS) ---
    const [busquedaUsuarios, setBusquedaUsuarios] = useState('');
    const [mostrarDesplegableUsuarios, setMostrarDesplegableUsuarios] = useState(false);
    const [opcionesUsuarios, setOpcionesUsuarios] = useState([]);

    // --- VINCULACIÓN DE ACORDEONES
    const [firmasMedidasOpen, setFirmasMedidasOpen] = useState(false);

    // --- ESTADOS LOTO (Vista y Edición) ---
    const [showBloqueoModal, setShowBloqueoModal] = useState(false);
    const [bloqueoActivo, setBloqueoActivo] = useState(null);
    const [showDescargoModal, setShowDescargoModal] = useState(false);
    const [descargoActivo, setDescargoActivo] = useState(null);
    // --- ESTADOS LOTO (ASIGNADOS MANUAL) ---
    const [hptLotoVirtual, setHptLotoVirtual] = useState(null);
    const [bloqueoIdx, setBloqueoIdx] = useState(null);
    const [descargoIdx, setDescargoIdx] = useState(null);

    // --- CONTROL DE MENÚS DESPLEGABLES DE FIRMAS ---
    const [activeDropdown, setActiveDropdown] = useState(null);

    // --- ESTADOS DE ANOTACIONES INCREMENTALES ---
    const [anotaciones, setAnotaciones] = useState([]);
    const [nuevaAnotacion, setNuevaAnotacion] = useState('');

    // --- MATRIZ DE FIRMAS (ESTADO INICIAL) ---
    // Esta es la estructura base. Si la BBDD ya tiene firmas, se sobrescribe en el fetchData
    const [firmasSecciones, setFirmasSecciones] = useState({
        consignacion: {
            'Jefe de Turno': { nombre: '', firma_path: null, fecha_hora: null },
            'Jefe de Trabajo': { nombre: '', firma_path: null, fecha_hora: null },
            'Resp. Contrata': { nombre: '', firma_path: null, fecha_hora: null }
        },
        medidas: {
            'Jefe de Trabajo': { nombre: '', firma_path: null, fecha_hora: null },
            'Recurso Preventivo': { nombre: '', firma_path: null, fecha_hora: null },
            'Resp. Contrata': { nombre: '', firma_path: null, fecha_hora: null }
        },
        trabajadores: {},
        apertura: {
            'Jefe Trabajo': { nombre: '', telefono: '', firma_path: null, fecha_hora: null },
            'Recurso Prev.': { nombre: '', telefono: '', firma_path: null, fecha_hora: null },
            'Resp. Contrata': { nombre: '', telefono: '', firma_path: null, fecha_hora: null },
            'Jefe de Turno': { nombre: '', hora_desde: '', hora_hasta: '', firma_path: null, fecha_hora: null }
        },
        cierre: {
            'Jefe Trabajo': { nombre: '', firma_path: null, fecha_hora: null },
            'Jefe de Turno': { nombre: '', firma_path: null, fecha_hora: null },
            'Comprobado en Campo': { nombre: '', firma_path: null, fecha_hora: null }
        }
    });

    // --- ESTADO Y ROL PARA MODO EXCEPCIONAL ---
    const [modoExcepcional, setModoExcepcional] = useState(false);

    const getUserPayload = () => {
        try {
            const token = localStorage.getItem('userToken');
            return token ? JSON.parse(atob(token.split('.')[1])) : null;
        } catch(e) { return null; }
    };
    const currentUser = getUserPayload();

    // ============================================================================
    // CARGA INICIAL
    // ============================================================================
    const fetchData = useCallback(async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            // Descargamos en paralelo para mayor velocidad
            const [resPtw, resActivos, resCatalogo, resUsuarios] = await Promise.all([
                axios.get(`${API_URL}/api/ptw/${id}`, config),
                axios.get(`${API_URL}/api/catalogos/activos`, config),
                axios.get(`${API_URL}/api/catalogos/seguridad`, config),
                axios.get(`${API_URL}/api/catalogos/usuarios`, config)
            ]);
            
            let data = resPtw.data;

            // 1. Resturamos Firmas Fijas Guardadas
            if (data.json_firmas && typeof data.json_firmas === 'object' && Object.keys(data.json_firmas).length > 0) {
                setFirmasSecciones({
                    ...data.json_firmas,
                    trabajadores: data.json_firmas.trabajadores || {}
                });
            }
            
            // 2. Resturamos Renovaciones Guardadas
            if (data.json_renovaciones && Array.isArray(data.json_renovaciones)) {
                setRenovaciones(data.json_renovaciones);
                setRenovacionesOriginal(JSON.parse(JSON.stringify(data.json_renovaciones)));
            }
            

            // 3. Si faltan nombres de responsables, los cogemos de la HPT original vinculada (si existe)
            if (!data.solicitante_nombre || data.solicitante_nombre.trim() === "") {
                data.solicitante_nombre = data.hpt?.nombre_completo_creador || "";
            }
            if (!data.recurso_preventivo_nombre || data.recurso_preventivo_nombre.trim() === "") {
                data.recurso_preventivo_nombre = data.hpt?.nombre_preventivo_hpt || "";
            }

            setPtw(data);
            setPtwOriginal(JSON.parse(JSON.stringify(data)));

            // 4. Cargar Historial de Anotaciones
            let historialAnotaciones = [];
            if (data.observaciones) {
                try {
                    historialAnotaciones = JSON.parse(data.observaciones);
                } catch (e) {
                    historialAnotaciones = [{ id: 1, fecha: data.fecha_trabajo || 'Anterior', texto: data.observaciones }];
                }
            }
            setAnotaciones(historialAnotaciones);

            // 5. Cargar Riesgos/Medidas (Se prioriza los del PTW sobre HPT (En revision))
            let riesgosFinales = [];
            if (data.riesgos_ptw_manual && data.riesgos_ptw_manual.length > 0) {
                riesgosFinales = data.riesgos_ptw_manual;
            } else {
                riesgosFinales = [
                    ...(data.hpt?.riesgos_detallados?.map(r => r.id_item) || []),
                    ...(data.hpt?.medidas_detalladas?.map(m => m.id_item) || [])
                ];
            }
            setSeleccionados(riesgosFinales);
            setSeleccionadosOriginal([...riesgosFinales]);

            setBusquedaActivo(data.codigo_activo || '');
            setCatalogo(resCatalogo.data);
            setLoading(false);
            setUsuarios(resUsuarios.data.results || resUsuarios.data);

        } catch (err) { 
            console.error("Error cargando PTW:", err);
            setLoading(false);
        }
    }, [id]);

    useEffect(() => { fetchData(); }, [fetchData]);

    // ============================================================================
    // FUNCIONES DE AUTOCOMPLETAR (ACTIVOS)
    // ============================================================================
    const buscarActivosEnServidor = async (texto) => {
        setBusquedaActivo(texto);
        if (texto.length < 2) {
            setOpcionesActivos([]);
            return;
        }
        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/catalogos/activos/buscar?q=${texto}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setOpcionesActivos(res.data.results || []);
        } catch (err) {
            console.error("Error buscando activos:", err);
        }
    };

    // ============================================================================
    // FUNCIONES BUSCAR USUARIOS RP
    // ==========================================================================
    const seleccionarActivo = (activo) => {
        setPtw({
            ...ptw,
            id_activo: activo.id_activo,
            den_act_snapshot: activo.denominacion
        });
        setBusquedaActivo(activo.codigo_activo);
        setMostrarDesplegable(false);
    };

    const buscarUsuariosServidor = async (texto) => {
        setBusquedaUsuarios(texto);
        if (texto.length < 2) {
            setOpcionesUsuarios([]);
            return;
        }
        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/catalogos/usuarios/buscar?q=${texto}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setOpcionesUsuarios(res.data.results || []);
        } catch (err) {
            console.error("Error buscando usuarios:", err);
        }
    };

    const seleccionarListaUsuarios = (opcion) => {
        const seleccion = opcion.valor;
        let current = ptw.recurso_preventivo_nombre || '';
        
        // Añadimos separado por coma si ya hay algo escrito
        if (current.trim() === '') {
            current = seleccion;
        } else if (!current.includes(seleccion)) {
            current = current + ', ' + seleccion;
        }
        
        setPtw({...ptw, recurso_preventivo_nombre: current});
        setBusquedaUsuarios('');
        setMostrarDesplegableUsuarios(false);
    };

    // ============================================================================
    // GUARDAR CANDADOS DESDE LAS HOJAS DE VISTA
    // ============================================================================
    const handleGuardarCandadoBloqueo = async (nuevoNumeroCandado) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            if (ptw.id_hpt_vinculada) {
                const bloqueosActualizados = ptw.hpt.bloqueos_electricos.map(b => b.id_item === bloqueoActivo.id_item ? { ...b, num_candado: nuevoNumeroCandado } : b);
                await axios.put(`${API_URL}/api/hpt/${ptw.id_hpt_vinculada}/descargos`, {
                    bloqueos_electricos: bloqueosActualizados, descargos_electricos: ptw.hpt.descargos_electricos || [], descargos_mecanicos: ptw.hpt.descargos_mecanicos || []
                }, config);
                setPtw({...ptw, hpt: {...ptw.hpt, bloqueos_electricos: bloqueosActualizados}});
            } else {
                const jDesc = ptw.json_descargos || {};
                const bloqueosActualizados = (jDesc.bloqueos_electricos || []).map(b => b.id_item === bloqueoActivo.id_item ? { ...b, num_candado: nuevoNumeroCandado } : b);
                const nuevoDescargos = { ...jDesc, bloqueos_electricos: bloqueosActualizados };
                await axios.put(`${API_URL}/api/ptw/${id}`, { ...ptw, json_descargos: nuevoDescargos }, config);
                setPtw({...ptw, json_descargos: nuevoDescargos});
            }
            Swal.fire({ title: 'Candado Registrado', icon: 'success', toast: true, position: 'top-end', showConfirmButton: false, timer: 2000 });
            setShowBloqueoModal(false);
        } catch (error) { Swal.fire('Error', 'No se pudo actualizar.', 'error'); }
    };

    const handleGuardarCandadoDescargo = async (nuevoNumeroCandado) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            if (ptw.id_hpt_vinculada) {
                const descargosActualizados = ptw.hpt.descargos_electricos.map(d => d.id_item === descargoActivo.id_item ? { ...d, num_candado: nuevoNumeroCandado } : d);
                await axios.put(`${API_URL}/api/hpt/${ptw.id_hpt_vinculada}/descargos`, {
                    bloqueos_electricos: ptw.hpt.bloqueos_electricos || [], descargos_electricos: descargosActualizados, descargos_mecanicos: ptw.hpt.descargos_mecanicos || []
                }, config);
                setPtw({...ptw, hpt: {...ptw.hpt, descargos_electricos: descargosActualizados}});
            } else {
                const jDesc = ptw.json_descargos || {};
                const descargosActualizados = (jDesc.descargos_electricos || []).map(d => d.id_item === descargoActivo.id_item ? { ...d, num_candado: nuevoNumeroCandado } : d);
                const nuevoDescargos = { ...jDesc, descargos_electricos: descargosActualizados };
                await axios.put(`${API_URL}/api/ptw/${id}`, { ...ptw, json_descargos: nuevoDescargos }, config);
                setPtw({...ptw, json_descargos: nuevoDescargos});
            }
            Swal.fire({ title: 'Candado Registrado', icon: 'success', toast: true, position: 'top-end', showConfirmButton: false, timer: 2000 });
            setShowDescargoModal(false);
        } catch (error) { Swal.fire('Error', 'No se pudo actualizar.', 'error'); }
    };

    // ============================================================================
    // VALIDADOR DE FIRMAS INCOMPLETAS
    // ============================================================================
    const validarFirmasIncompletas = () => {
        for (const [seccion, roles] of Object.entries(firmasSecciones)) {
            if (seccion === 'trabajadores') continue;

            for (const [rol, datos] of Object.entries(roles)) {
                if (datos?.firma_path) {
                    if (!datos.nombre || datos.nombre.trim() === '') {
                        return `Falta escribir el NOMBRE junto a la firma de ${rol} (Sección: ${seccion.toUpperCase()}).`;
                    }
                    if (seccion === 'apertura') {
                        if (rol === 'Jefe de Turno') {
                            if (!datos.hora_desde || !datos.hora_hasta) return `Faltan las HORAS (desde/hasta) en la apertura del Jefe de Turno.`;
                        } else {
                            if (!datos.telefono || datos.telefono.trim() === '') return `Falta el TELÉFONO junto a la firma de ${rol} en la apertura.`;
                        }
                    }
                }
            }
        }
        for (let i = 0; i < renovaciones.length; i++) {
            const ren = renovaciones[i];
            for (const [rol, datos] of Object.entries(ren.firmas)) {
                if (datos?.firma_path) {
                    if (!datos.nombre || datos.nombre.trim() === '') {
                        return `Falta escribir el NOMBRE junto a la firma de ${rol} (Renovación ${i + 1}).`;
                    }
                    if (rol === 'Jefe de Turno') {
                        if (!datos.hora_desde || !datos.hora_hasta) return `Faltan las HORAS (desde/hasta) en la firma del Jefe de Turno (Renovación ${i + 1}).`;
                    }
                }
            }
        }
        return null; 
    };

    // ============================================================================
    // VALIDADOR PARA MOSTRAR BOTÓN DE FIRMA EN TIEMPO REAL
    // ============================================================================
    const puedeFirmar = (seccion, rol, idx = null) => {

        if (ptw?.estado === 'cerrado' || ptw?.estado === 'anulado') return false;

        if (seccion === 'trabajadores') return true;

        let datos;
        if (seccion === 'renovacion' && idx !== null) {
            datos = renovaciones[idx]?.firmas[rol];
        } else {
            datos = firmasSecciones[seccion]?.[rol];
        }

        if (!datos) return false;
        
        // Nombre obligatorio
        if (!datos.nombre || datos.nombre.trim().length < 2) return false;

        // Correo obligatorio si es externo
        const esExterno = !usuarios.some(u => `${u.nombre} ${u.apellidos}`.toLowerCase() === datos.nombre.trim().toLowerCase());
        if (esExterno && (!datos.correo_externo || datos.correo_externo.trim() === '')) return false;

        // Revisar campos extra según la sección
        if (seccion === 'apertura') {
            if (rol === 'Jefe de Turno') {
                if (!datos.hora_desde || !datos.hora_hasta) return false;
            } else {
                if (!datos.telefono || datos.telefono.trim() === '') return false;
            }
        }
        
        if (seccion === 'renovacion') {
            if (rol === 'Jefe de Turno') {
                if (!datos.hora_desde || !datos.hora_hasta) return false;
            }
        }

        return true;
    };

    // ============================================================================
    // Guardar en servidor
    // ============================================================================
    const handleGuardarTodo = async () => {

        const errorFirmaIncompleta = validarFirmasIncompletas();
        if (errorFirmaIncompleta) {
            Swal.fire({
                title: 'Datos Incompletos',
                text: errorFirmaIncompleta,
                icon: 'warning',
                confirmButtonColor: '#f57c00'
            });
            return; 
        }

        const token = localStorage.getItem('userToken');
        const arraysSonIguales = (a, b) => JSON.stringify([...a].sort()) === JSON.stringify([...b].sort());
        const riesgosModificados = !arraysSonIguales(seleccionados, seleccionadosOriginal);
        
        const hayCambiosCriticos = 
            ptw.alcance !== ptwOriginal.alcance ||
            ptw.descripcion_trabajo !== ptwOriginal.descripcion_trabajo ||
            ptw.id_activo !== ptwOriginal.id_activo ||
            ptw.fecha_trabajo !== ptwOriginal.fecha_trabajo ||
            ptw.rango_horario !== ptwOriginal.rango_horario ||
            ptw.recurso_preventivo_nombre !== ptwOriginal.recurso_preventivo_nombre ||
            riesgosModificados;

        // Intercepcion de Modificaciones en puntos importantes.
        let anotacionForzada = null;
        let nuevoEstado = calcularNuevoEstado();

        if (modoExcepcional) {
            const { value: justificacion, isDismissed } = await Swal.fire({
                title: '¡ALERTA CRÍTICA!',
                text: 'Estás modificando Riesgos en un Permiso ACTIVO. Esto pasará el PTW a estado DETENIDO y su único fin será ANULARLO. Se generará un CLON exacto de su HPT original con los nuevos riesgos para reiniciar el proceso. ¿Estás seguro?',
                input: 'textarea',
                inputPlaceholder: 'Justificación OBLIGATORIA para la anulación...',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#d32f2f',
                confirmButtonText: 'Sí, DETENER y programar Anulación',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value || value.trim() === '') return '¡Debes justificar esta acción!';
                }
            });

            if (isDismissed || !justificacion) {
                setModoExcepcional(false);
                return;
            }

            nuevoEstado = 'detenido_anulacion';
            anotacionForzada = `[ANULACIÓN PROGRAMADA] Se han modificado los riesgos con el permiso en curso. El PTW queda inmovilizado a la espera de firmas de cierre. \n🗣️ Motivo: ${justificacion.trim()}`;
            setModoExcepcional(false);

        } else if (riesgosModificados && !isPtwAbiertoOCerrado) {

            // Autodetectamos que se ha añadido o quitado
            const agregadosIds = seleccionados.filter(id => !seleccionadosOriginal.includes(id));
            const eliminadosIds = seleccionadosOriginal.filter(id => !seleccionados.includes(id));

            // Buscamos los textos reales en el catálogo
            const getDescripcion = (id) => catalogo.find(c => c.id_item === id)?.descripcion || `Item ${id}`;

            const txtAgregados = agregadosIds.length > 0 ? `Agregado: ${agregadosIds.map(getDescripcion).join(', ')}` : '';
            const txtEliminados = eliminadosIds.length > 0 ? `Eliminado: ${eliminadosIds.map(getDescripcion).join(', ')}` : '';

            // Juntamos todo en un resumen limpio
            const resumenCambios = [txtAgregados, txtEliminados].filter(Boolean).join('\n');

            const { value: justificacion, isDismissed } = await Swal.fire({
                title: 'Modificación de Riesgos/Medidas',
                text: 'Has modificado las condiciones de seguridad. Es OBLIGATORIO justificar este cambio para notificar a los implicados.',
                input: 'textarea',
                inputPlaceholder: 'Escribe el motivo del cambio aquí...',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Guardar y Notificar',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value || value.trim() === '') return '¡Debes escribir una justificación!';
                }
            });

            if (isDismissed || !justificacion) {
                return;
            }
            anotacionForzada = `[CAMBIO DE RIESGOS/MEDIDAS]\n${resumenCambios} Motivo: ${justificacion.trim()}`;
        }

        
        if (hayCambiosCriticos && (ptwOriginal.estado === 'abierto' || ptwOriginal.estado === 'renovado' || ptwOriginal.estado === 'detenido')) {
            if (nuevoEstado !== 'detenido_anulacion') {
                nuevoEstado = 'detenido';
            }
        }
        
        const clean = (val) => (val === "" || val === undefined ? null : val);

        // Preparamos el historial de observaciones sumando la forzada
        let historialActualizado = [...anotaciones];
        if (anotacionForzada) {
            const nueva = {
                id: Date.now(),
                fecha: new Date().toLocaleString(),
                texto: anotacionForzada
            };
            historialActualizado.push(nueva);
            setAnotaciones(historialActualizado);
        }

        const payload = {
            alcance: clean(ptw.alcance),
            estado: nuevoEstado,
            solicitante_nombre: clean(ptw.solicitante_nombre),
            recurso_preventivo_nombre: clean(ptw.recurso_preventivo_nombre),
            id_activo: ptw.id_activo ? parseInt(ptw.id_activo) : null,
            ot_asociada: clean(ptw.ot_asociada),
            fecha_trabajo: clean(ptw.fecha_trabajo),
            rango_horario: clean(ptw.rango_horario),
            numero_caja: clean(ptw.numero_caja),
            candado_operacion: clean(ptw.candado_operacion),
            candado_ejecutante: clean(ptw.candado_ejecutante),
            descripcion_trabajo: clean(ptw.descripcion_trabajo),
            observaciones: JSON.stringify(historialActualizado),
            
            firmas_secciones: firmasSecciones,
            renovaciones: renovaciones,
            seleccionados_seguridad: seleccionados,
            
            notificar_cambio_riesgos: riesgosModificados
        };

        try {
            await axios.put(`${API_URL}/api/ptw/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            setPtw({...ptw, estado: nuevoEstado, observaciones: JSON.stringify(historialActualizado)}); 
            setPtwOriginal(JSON.parse(JSON.stringify({...ptw, estado: nuevoEstado, observaciones: JSON.stringify(historialActualizado)})));
            setSeleccionadosOriginal([...seleccionados]);
            setRenovacionesOriginal(JSON.parse(JSON.stringify(renovaciones)));

            if (nuevoEstado === 'detenido' && ptwOriginal.estado !== 'detenido') {
                Swal.fire('¡PERMISO DETENIDO!', 'Has modificado condiciones críticas. El permiso queda paralizado hasta que se firme una nueva renovación.', 'warning');
            } else {
                Swal.fire({ title: 'Guardado', text: `Estado actual: ${nuevoEstado.toUpperCase()}`, icon: 'success', toast: true, position: 'top-end', showConfirmButton: false, timer: 2000 });
            }
        } catch (err) {
            Swal.fire("Error", "Error al guardar. Verifica la conexión.", "error");
        }
    };

    // ============================================================================
    // GESTIÓN DE FIRMAS (PAD)
    // ============================================================================
    // Se ejecuta al dar clic en el botón de firmar
    const handleOpenSignature = (type, section, idx = null, rol = null) => {
        // Guardamos las coordenadas (Ej: type:'fija', section:'apertura', rol:'Jefe Trabajo')
        setCurrentSignType({ type, section, idx, rol });
        setShowSignature(true); // Abre el Pad de firmas
    };

    // Se ejecuta cuando el Pad nos devuelve la imagen Base64
    const handleSaveSignature = (signatureBase64) => {
        const now = new Date().toLocaleString(); // Registramos la hora exacta de la firma

        if (currentSignType.type === 'renovacion') {
            // Guarda en la sección de renovaciones
            const nuevas = [...renovaciones];
            nuevas[currentSignType.idx].firmas[currentSignType.rol].firma_path = signatureBase64;
            nuevas[currentSignType.idx].firmas[currentSignType.rol].fecha_hora = now;
            setRenovaciones(nuevas);
        } else {
            // Guarda en la sección de Firmas Fijas (Apertura, Cierre, etc.)
            setFirmasSecciones(prev => ({
                ...prev,
                [currentSignType.section]: {
                    ...prev[currentSignType.section],
                    [currentSignType.rol]: {
                        ...prev[currentSignType.section][currentSignType.rol],
                        firma_path: signatureBase64,
                        fecha_hora: now
                    }
                }
            }));
        }
        setShowSignature(false); // Cierra el Pad
    };

    // Actualiza textos como el nombre o el telefono.
    const updateFirmaData = (section, rol, field, val) => {
        setFirmasSecciones(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [rol]: { ...prev[section][rol], [field]: val }
            }
        }));
    };

    const toggleItem = (idItem) => {
        setSeleccionados(prev => prev.includes(idItem) ? prev.filter(i => i !== idItem) : [...prev, idItem]);
    };

    // Añade bloque vacío para cada renovación (MAX 6)
    const addRenovacion = () => {
        if (ptw?.estado === 'cerrado' || ptw?.estado === 'anulado') return;
        if (renovaciones.length >= 6) {
            Swal.fire('Límite Alcanzado', 'No se pueden añadir más de 6 renovaciones a este Permiso de Trabajo.', 'warning');
            return;
        }

        const rolesBase = ['Jefe Trabajo', 'Recurso Prev.'];
        if (ptw.hpt?.interviene_subcontrata) rolesBase.push('Resp. Contrata');
        
        const nueva = {
            id_temp: Date.now(),
            fecha: new Date().toISOString().split('T')[0],
            firmas: {
                ...rolesBase.reduce((acc, rol) => {
                    acc[rol] = { nombre: '', telefono: '', firma_path: null, fecha_hora: null };
                    return acc;
                }, {}),
                'Jefe de Turno': { nombre: '', hora_desde: '', hora_hasta: '', firma_path: null, fecha_hora: null }
            }
        };
        setRenovaciones([...renovaciones, nueva]);
    };

    // ============================================================================
    // OBSERVACIONES GUARDADAS INDEPENDIENTEMENTE
    // ============================================================================
    const handleGuardarObservaciones = async () => {
        if (!nuevaAnotacion.trim()) return;
        const token = localStorage.getItem('userToken');
        
        const nueva = {
            id: Date.now(),
            fecha: new Date().toLocaleString(),
            texto: nuevaAnotacion.trim()
        };
        const nuevoHistorial = [...anotaciones, nueva];

        try {
            await axios.put(`${API_URL}/api/ptw/${id}/observaciones`, {
                observaciones: JSON.stringify(nuevoHistorial)
            }, { headers: { Authorization: `Bearer ${token}` } });
            
            setAnotaciones(nuevoHistorial);
            setNuevaAnotacion('');
            setPtw({...ptw, observaciones: JSON.stringify(nuevoHistorial)});
            
            Swal.fire({ title: 'Anotación Guardada', text: 'Se ha enviado un aviso a los implicados.', icon: 'success', toast: true, position: 'top-end', showConfirmButton: false, timer: 3000 });
        } catch (error) {
            Swal.fire("Error", "No se pudo enviar la anotación.", "error");
        }
    };

    // ============================================================================
    // LÓGICA DE PTW
    // ============================================================================
    if (loading) return <div style={{padding: '50px'}}>Cargando PTW...</div>;

    const intervieneSubcontrata = ptw.hpt?.interviene_subcontrata === 1 || ptw.hpt?.interviene_subcontrata === true;
    
    // Extraemos los riegos y medidas
    const categoriasRiesgo = [...new Set(catalogo.filter(i => i.es_riesgo).map(i => i.categoria))];
    const categoriasMedida = [...new Set(catalogo.filter(i => !i.es_riesgo).map(i => i.categoria))];

    // FUNCIÓN MAESTRA: Revisa si una sección entera (ej: Cierre) tiene TODAS sus firmas
    const seccionEstaCompleta = (seccion) => {
        const firmas = firmasSecciones[seccion];
        if (!firmas) return false;

        let rolesRequeridos = Object.keys(firmas);
        // Filtramos para ignorar la firma de subcontrata si no aplica
        if (!intervieneSubcontrata) {
            rolesRequeridos = rolesRequeridos.filter(rol => rol !== 'Resp. Contrata');
        }

        // Devuelve TRUE solo si TODOS los roles obligatorios tienen imagen (firma_path) y nombre escrito
        return rolesRequeridos.every(rol => 
            firmas[rol]?.firma_path !== null && 
            firmas[rol]?.nombre && 
            firmas[rol]?.nombre.trim() !== ""
        );
    };

    // LÓGICA DE FIRMAS: Bloquea los apartados de firmas que no deben ser firmado sin hacer los anteriores antes
    const puedeFirmarApertura = seccionEstaCompleta('medidas');

    const isRenovacionCompleta = (ren) => {
        if (!ren) return false;
        let rolesRequeridos = Object.keys(ren.firmas);
        if (!intervieneSubcontrata) {
            rolesRequeridos = rolesRequeridos.filter(rol => rol !== 'Resp. Contrata');
        }
        return rolesRequeridos.every(rol => 
            ren.firmas[rol]?.firma_path !== null && 
            ren.firmas[rol]?.nombre && 
            ren.firmas[rol]?.nombre.trim() !== ""
        );
    };

    // Autocalcula el estado del PTW basándose en las secciones completadas
    const calcularNuevoEstado = () => {
        if (seccionEstaCompleta('cierre')) {
            return ptwOriginal?.estado === 'detenido_anulacion' ? 'anulado' : 'cerrado';
        }
        
        if (ptwOriginal?.estado === 'detenido_anulacion') return 'detenido_anulacion';
        if (ptwOriginal?.estado === 'anulado') return 'anulado';
        
        const numRenovaciones = renovaciones.length;
        
        if (numRenovaciones > 0) {
            const ultimaRenovacion = renovaciones[numRenovaciones - 1];
            const ultimaOriginal = renovacionesOriginal[numRenovaciones - 1];
            
            const ultimaCompleta = isRenovacionCompleta(ultimaRenovacion);
            const originalCompleta = isRenovacionCompleta(ultimaOriginal);

            if (ultimaCompleta) {
                if (ptwOriginal?.estado === 'detenido') {
                    // Si ya estaba completa antes de guardar, es la jornada antigua -> Sigue bloqueado
                    // Si ANTES no estaba completa y AHORA sí -> Acaban de terminarla -> ¡Avanza!
                    if (!originalCompleta) return "renovado";
                    return "detenido";
                }
                return "renovado";
            }
            
            if (ptwOriginal?.estado === 'detenido') return "detenido";
            if (ptwOriginal?.estado === 'renovado') return "renovado";
        }
        
        if (ptwOriginal?.estado === 'detenido') return "detenido";
        if (seccionEstaCompleta('apertura')) return "abierto";
        
        return ptw.estado || "creado";
    };

    // Configuración de la UI para el Estado
    const getStatusConfig = (estado) => {
        switch (estado) {
            case 'cerrado': return { icon: '🏁', color: '#d32f2f' };
            case 'anulado': return { icon: '❌', color: '#b71c1c' }; 
            case 'detenido_anulacion': return { icon: '🛑', color: '#e65100' };
            case 'abierto': return { icon: '🔓', color: '#2e7d32' };
            case 'renovado': return { icon: '⏳', color: '#1a237e' };
            case 'detenido': return { icon: '🛑', color: '#e65100' };
            default: return { icon: '📝', color: '#f57c00' };
        }
    };


    // Extracción dinámica de descargos desde la HPT/PTW
    let bloqueos = [];
    let descargos = [];
    let mecanicos = [];
    let trabajosPrevios = [];
    if (ptw.id_hpt_vinculada) {
        // Viene de HPT: Leemos sus matrices de objetos
        bloqueos = ptw.hpt?.bloqueos_electricos || [];
        descargos = ptw.hpt?.descargos_electricos || [];
        mecanicos = ptw.hpt?.descargos_mecanicos || [];
        trabajosPrevios = ptw.hpt?.trabajos_previos || [];
    } else {
        // Es un PTW Directo: Leemos su JSON
        const jDesc = ptw.json_descargos || {};
        bloqueos = jDesc.bloqueos_electricos || [];
        descargos = jDesc.descargos_electricos || [];
        mecanicos = jDesc.descargos_mecanicos || [];
        trabajosPrevios = jDesc.trabajos_previos || [];
    }

    // Consignación LOTO (Ahora se calcula viendo si hay algún tag en los arrays)
    const necesitaConsignacion = bloqueos.length > 0 || descargos.length > 0 || mecanicos.length > 0;

    // Para ver el LOTO del PTW / HPT Asociado
    const handleVerLoto = async (elementoLoto, tipo, hptActual, index) => {
        if (elementoLoto.ptw_vinculado) {
            Swal.fire({title: 'Buscando descargo original...', allowOutsideClick: false, didOpen: () => Swal.showLoading()});
            try {
                const token = localStorage.getItem('userToken');
                const res = await axios.get(`${API_URL}/api/ptw/loto/vinculado?ptw=${encodeURIComponent(elementoLoto.ptw_vinculado)}`, { 
                    headers: { Authorization: `Bearer ${token}` }
                });
                Swal.close();
                
                const lista = tipo === 'bloqueo' ? res.data.bloqueos : res.data.descargos;
                const itemReal = lista.find(x => Number(x.num_consignacion) === Number(elementoLoto.num_consignacion));
                
                if (itemReal) {
                    setHptLotoVirtual({ ...res.data.hpt, numero_ptw: elementoLoto.ptw_vinculado });
                    if (tipo === 'bloqueo') {
                        setBloqueoActivo(itemReal);
                        setBloqueoIdx(index);
                        setShowBloqueoModal(true);
                    } else {
                        setDescargoActivo(itemReal);
                        setDescargoIdx(index);
                        setShowDescargoModal(true);
                    }
                } else {
                    Swal.fire('Aviso', `El PTW ${elementoLoto.ptw_vinculado} existe, pero no tiene registrado el número de consignación ${elementoLoto.num_consignacion}.`, 'warning');
                }
            } catch(e) {
                Swal.fire('Error', 'No se pudo cargar el PTW vinculado. Asegúrate de que está escrito correctamente (Ej: 26/0045).', 'error');
            }
        } else {
            // MAGIA AQUÍ: Inyectamos el PTW de la pantalla si es un LOTO normal
            setHptLotoVirtual({ ...(hptActual || {}), numero_ptw: ptw.id_ptw_formato });
            if (tipo === 'bloqueo') {
                setBloqueoActivo(elementoLoto);
                setBloqueoIdx(index);
                setShowBloqueoModal(true);
            } else {
                setDescargoActivo(elementoLoto);
                setDescargoIdx(index);
                setShowDescargoModal(true);
            }
        }
    };


    // ============================================================================
    // EXPORTACIÓN A PDF
    // ===========================================================================
    
    const handlePrint = () => {
        const element = pdfRef.current;
        if (!element) return;

        const opt = {
            margin:       0,
            filename:     `PTW_${ptw?.id_ptw_formato || 'Documento'}.pdf`,
            image:        { type: 'jpeg', quality: 0.98 },
            html2canvas:  { scale: 2, useCORS: true, logging: false },
            jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        // Genera y descarga el PDF automáticamente
        html2pdf().set(opt).from(element).save();
    };


    // ============================================================================
    // COMPONENTE DEL NOMBRE PARA FIRMAS
    // ============================================================================
    const renderInputNombre = (seccion, rol, disabledControl) => {
        const firma = firmasSecciones[seccion]?.[rol];
        const nombreEscrito = firma?.nombre || '';
        const yaEstaFirmado = firma?.firma_path !== null;
        // Es externo si hay texto y NO existe un usuario en la BD con ese mismo nombre + apellidos
        const esExterno = nombreEscrito && !usuarios.some(u => `${u.nombre} ${u.apellidos}`.toLowerCase() === nombreEscrito.toLowerCase());
        const dropKey = `${seccion}-${rol}`;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '4px', position: 'relative' }}>
                <input 
                    type="text"
                    placeholder="Nombre completo" 
                    className="mini-input-table"
                    value={nombreEscrito} 
                    onChange={e => {
                        updateFirmaData(seccion, rol, 'nombre', e.target.value);
                        setActiveDropdown(dropKey); // Abrimos el menú de esta celda
                    }} 
                    onFocus={() => setActiveDropdown(dropKey)}
                    onBlur={() => setTimeout(() => setActiveDropdown(null), 200)}
                    disabled={disabledControl || yaEstaFirmado}
                />
                
                {/* Menú Flotante de Resultados */}
                {activeDropdown === dropKey && nombreEscrito.length >= 2 && (
                    <div style={{ position: 'relative', width: '100%', zIndex: 999999 }}>
                        <ul className="autocomplete-list" style={{ 
                            position: 'relative', 
                            top: '2px', 
                            left: 0, 
                            right: 0, 
                            zIndex: 999999, 
                            fontSize: '11px', 
                            textAlign: 'left', 
                            maxHeight: '140px',
                            overflowY: 'auto',
                            boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                            backgroundColor: '#fff',
                            border: '1px solid #b0bec5',
                        }}>
                            {usuarios.filter(u => `${u.nombre} ${u.apellidos}`.toLowerCase().includes(nombreEscrito.toLowerCase())).map(u => (
                                <li 
                                    key={u.id_usuario} 
                                    className="autocomplete-item"
                                    onMouseDown={() => {
                                        seccion === 'renovacion' 
                                            ? (() => { const n = [...renovaciones]; n[rol.idx].firmas[rol.rol].nombre = `${u.nombre} ${u.apellidos}`; setRenovaciones(n); })()
                                            : updateFirmaData(seccion, rol, 'nombre', `${u.nombre} ${u.apellidos}`);
                                        setActiveDropdown(null);
                                    }}
                                    style={{ padding: '8px 10px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                                >
                                    <strong>{u.nombre} {u.apellidos}</strong><br/>
                                    <span className="text-small text-muted">{u.rol} — {u.grupo}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {/* Si es Externo, mostramos el correo */}
                {esExterno && (
                    <input 
                        type="email"
                        placeholder="Correo (Para avisos)"
                        className="mini-input-table"
                        style={{ borderColor: '#f57c00', backgroundColor: '#fff3e0' }}
                        value={firma?.correo_externo || ''}
                        onChange={e => updateFirmaData(seccion, rol, 'correo_externo', e.target.value)}
                        disabled={disabledControl || yaEstaFirmado}
                    />
                )}
            </div>
        );
    };

    const renderInputNombreRenovacion = (idx, rol) => {
        const firma = renovaciones[idx].firmas[rol];
        const nombreEscrito = firma?.nombre || '';
        const esExterno = nombreEscrito && !usuarios.some(u => `${u.nombre} ${u.apellidos}`.toLowerCase() === nombreEscrito.toLowerCase());
        const dropKey = `renovacion-${idx}-${rol}`;
        const yaEstaFirmado = firma?.firma_path !== null;

        return (
            

            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '4px', position: 'relative', zIndex: activeDropdown === dropKey ? 9999 : 1 }}>
                <input 
                    type="text"
                    placeholder="Nombre completo" 
                    className="mini-input-table"
                    value={nombreEscrito} 
                    onChange={e => {
                        const n = [...renovaciones]; n[idx].firmas[rol].nombre = e.target.value; setRenovaciones(n);
                        setActiveDropdown(dropKey);
                    }} 
                    onFocus={() => setActiveDropdown(dropKey)}
                    onBlur={() => setTimeout(() => setActiveDropdown(null), 200)}
                    disabled={yaEstaFirmado}
                />
                
                {/* Menú Flotante de Resultados */}
                {activeDropdown === dropKey && nombreEscrito.length >= 2 && (
                    <div style={{ position: 'relative', width: '100%', zIndex: 999999 }}>
                        <ul className="autocomplete-list" style={{ 
                            position: 'relative', 
                            top: '2px', 
                            left: 0, 
                            right: 0, 
                            zIndex: 999999, 
                            fontSize: '11px', 
                            textAlign: 'left', 
                            maxHeight: '140px',
                            overflowY: 'auto',
                            boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                            backgroundColor: '#fff',
                            border: '1px solid #b0bec5',
                        }}>
                            {usuarios.filter(u => 
                                `${u.nombre} ${u.apellidos}`.toLowerCase().includes(nombreEscrito.toLowerCase())
                            ).map(u => (
                                <li 
                                    key={u.id_usuario} 
                                    className="autocomplete-item"
                                    onMouseDown={() => {
                                        const n = [...renovaciones]; n[idx].firmas[rol].nombre = `${u.nombre} ${u.apellidos}`; setRenovaciones(n);
                                        setActiveDropdown(null);
                                    }}
                                    style={{ padding: '6px 10px' }}
                                >
                                    <strong>{u.nombre} {u.apellidos}</strong><br/>
                                    <span className="text-small text-muted">{u.rol} — {u.grupo}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                    
                {esExterno && (
                    <input 
                        type="email"
                        placeholder="Correo (Para avisos)"
                        className="mini-input-table"
                        style={{ borderColor: '#f57c00', backgroundColor: '#fff3e0' }}
                        value={firma?.correo_externo || ''}
                        disabled={yaEstaFirmado}
                        onChange={e => {
                            const n = [...renovaciones]; n[idx].firmas[rol].correo_externo = e.target.value; setRenovaciones(n);
                        }}
                    />
                )}
            </div>
        );
    };

    // --- VARIABLES DE CONTROL DE BLOQUEO DE INTERFAZ ---
    const isCerradoOAnulado = ptw?.estado === 'cerrado' || ptw?.estado === 'anulado';
    const isPtwAbiertoOCerrado = ptw?.estado !== 'creado' && ptw?.estado !== 'detenido';
    const isConsignacionBloqueada = seccionEstaCompleta('consignacion');
    const isMedidasBloqueadas = !modoExcepcional && (isPtwAbiertoOCerrado || Object.values(firmasSecciones.medidas).some(firma => firma?.firma_path !== null));

    // ============================================================================
    // RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="container">
            {/* DICCIONARIO INVISIBLE DE USUARIOS (Para autocompletar) */}
            <datalist id="lista-usuarios-planta">
                {usuarios.map(u => <option key={u.id_usuario} value={`${u.nombre} ${u.apellidos}`} />)}
            </datalist>
            {/* 1. ENCABEZADO CON GUARDADO */}
            <div className="top-header header-ptw">
                <div className="d-flex align-center">
                    <span className="ptw-label">PERMISO:</span>
                    <div className="ptw-badge-alt">
                        <span style={{ fontSize: '20px' }}>📄</span> 
                        {ptw.id_ptw_formato}
                    </div>
                </div>
                
                {/* Estado PTW Autocalculado */}
                <div className="d-flex align-center mt-10 mb-20">
                    <span className="ptw-label">ESTADO DEL PERMISO:</span>
                    <div className="status-badge-main" style={{ backgroundColor: getStatusConfig(ptw.estado).color }}>
                        <span style={{ fontSize: '18px' }}>{getStatusConfig(ptw.estado).icon}</span>
                        {ptw.estado ? ptw.estado.toUpperCase().replace('_', ' ') : 'CREADO'}
                    </div>
                </div>
                <div className="header-actions">
                    {(ptw.estado === 'abierto' || ptw.estado === 'renovado') && 
                        (currentUser?.rol === 'JEFE_TURNO' || currentUser?.rol === 'GESTOR') && 
                        !modoExcepcional && (
                        <button onClick={() => setModoExcepcional(true)} className="btn-print" style={{backgroundColor: '#d32f2f', color: 'white'}}>
                            ⚠️ Modificar Riesgos (Forzar Anulación)
                        </button>
                    )}
                    {modoExcepcional && (
                        <span style={{ color: '#d32f2f', fontWeight: 'bold', marginRight: '10px' }}>
                            ⚠️ MODO EXCEPCIONAL ACTIVO
                        </span>
                    )}
                    <button 
                        onClick={handleGuardarTodo} 
                        className="btn-save" 
                        disabled={isCerradoOAnulado}
                        style={{ 
                            opacity: isCerradoOAnulado ? 0.5 : 1, 
                            cursor: isCerradoOAnulado ? 'not-allowed' : 'pointer',
                            backgroundColor: isCerradoOAnulado ? '#9e9e9e' : ''
                        }}
                    >
                        💾 Guardar Cambios
                    </button>
                    <button onClick={handlePrint} className="btn-print">🖨️ Imprimir PDF</button>
                    <button onClick={() => navigate('/dashboard')} className="btn-close">Cerrar</button>
                </div>
            </div>

            {/* 2. DATOS GENERALES */}
            <div className="main-card">
                <div className="row">
                    <div className="d-flex flex-1" style={{ flexDirection:'column', flex: 2 }}>
                        <label className="info-label">ALCANCE:</label>
                        <textarea 
                            className="main-textarea"
                            value={ptw.alcance || ''} 
                            disabled={true}
                            onChange={e => setPtw({...ptw, alcance: e.target.value})} 
                        />
                    </div>
                    <div className="field">
                        <label className="info-label">SOLICITANTE:</label>
                        <input 
                            className="input-solicitante"
                            value={ptw.solicitante_nombre} 
                            onChange={e => setPtw({...ptw, solicitante_nombre: e.target.value})} 
                        />
                    </div>
                </div>
                
                {/* BUSCADOR AUTOCOMPLETAR ACTIVOS */}
                <div className="asset-section-hpt" style={{ marginBottom: '15px' }}>
                    <div className="row">
                        <div className="info-box flex-1 relative">
                            <span className="info-label">CÓDIGO ACTIVO (Buscador):</span>
                            <input 
                                type="text" 
                                className="main-input" 
                                placeholder="Escriba código o nombre..."
                                value={busquedaActivo}
                                onChange={(e) => {
                                    buscarActivosEnServidor(e.target.value);
                                    setMostrarDesplegable(true);
                                    if (ptw.id_activo) {
                                        setPtw({...ptw, id_activo: null, den_act_snapshot: ''});
                                    }
                                }}
                                onFocus={() => setMostrarDesplegable(true)}
                                onBlur={() => setTimeout(() => setMostrarDesplegable(false), 200)}
                            />

                            {mostrarDesplegable && busquedaActivo.length >= 2 && (
                                <ul className="autocomplete-list">
                                    {opcionesActivos.length > 0 ? (
                                        opcionesActivos.map(a => (
                                            <li 
                                                key={a.id_activo} 
                                                className="autocomplete-item"
                                                onMouseDown={() => seleccionarActivo(a)} 
                                            >
                                                <strong>{a.codigo_activo}</strong> <br/>
                                                <span className="text-small text-muted">{a.denominacion}</span>
                                            </li>
                                        ))
                                    ) : (
                                        <li className="autocomplete-item">No se encontraron activos...</li>
                                    )}
                                </ul>
                            )}
                        </div>
                        
                        <div className="info-box flex-2 asset-display-box">
                            <span className="info-label">DENOMINACIÓN DEL EQUIPO:</span>
                            <div className="asset-name-text">
                                {ptw.den_act_snapshot || 'Seleccione un activo en el buscador...'}
                            </div>
                        </div>

                        <div className="info-box flex-1">
                            <label className="info-label">OT ASOCIADA:</label>
                            <input value={ptw.ot_asociada || ''} disabled={true} onChange={e => setPtw({...ptw, ot_asociada: e.target.value})} className="main-input" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="field">
                        <label className="info-label">FECHA Y DÍAS PREVISTOS:</label>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <input 
                                type="date" 
                                value={ptw.fecha_trabajo || ''} 
                                disabled={true} 
                                className="main-input" 
                                style={{ flex: 1 }}
                            />
                            <div className="main-input"
                            >
                                {ptw.hpt?.dias_previstos || ptw.dias_previstos || 1} {(ptw.hpt?.dias_previstos === 1 || ptw.dias_previstos === 1 || (!ptw.hpt?.dias_previstos && !ptw.dias_previstos)) ? 'Día' : 'Días'}
                            </div>
                        </div>
                    </div>
                    <div className="field">
                        <label className="info-label">HORARIO:</label>
                        <input 
                            value={ptw.rango_horario || ''} 
                            disabled={true} 
                            className="main-input" 
                        />
                    </div>
                </div>
            </div>

            {/* 3. DESCARGOS LOTO */}
            <ExpandableCard title="Descargos y Trabajos Previos" icon="⚙️">
                <div className="loto-tags-container" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    
                    {/* Bloqueos Eléctricos */}
                    <div>
                        <strong style={{ fontSize: '13px', color: '#1a237e' }}>Bloqueos Eléctricos ({bloqueos.length}):</strong>
                        {bloqueos.length > 0 ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                {bloqueos.map((b, i) => (
                                    <span 
                                        key={i} 
                                        className="skill-tag" 
                                        style={{ backgroundColor: '#90caf9', color: '#1a237e', padding: '6px 12px', fontSize: '13px', cursor: 'pointer', border: '1px solid #1a237e' }}
                                        onClick={() => handleVerLoto(b, 'bloqueo', ptw.hpt, i)}
                                    >
                                        🔒 {b.num_consignacion ? `[Nº ${b.num_consignacion}] ` : ''}{b.activo} {b.num_candado ? `(Candado: ${b.num_candado})` : '(⚠️ Sin candado)'}
                                    </span>
                                ))}
                            </div>
                        ) : <p style={{ fontSize: '12px', color: '#666', margin: '5px 0' }}>No requiere bloqueos eléctricos.</p>}
                    </div>

                    {/* Descargos Eléctricos */}
                    <div style={{ marginTop: '15px' }}>
                        <strong style={{ fontSize: '13px', color: '#e65100' }}>Descargos Eléctricos ({descargos.length}):</strong>
                        {descargos.length > 0 ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                {descargos.map((d, i) => (
                                    <span 
                                        key={i} 
                                        className="skill-tag" 
                                        style={{ backgroundColor: '#ffe0b2', color: '#e65100', padding: '6px 12px', fontSize: '13px', cursor: 'pointer', border: '1px solid #e65100' }}
                                        onClick={() => handleVerLoto(d, 'descargo', ptw.hpt, i)}
                                    >
                                        ⚡ {d.num_consignacion ? `[Nº ${d.num_consignacion}] ` : ''}{d.activo} {d.num_candado ? `(Candado: ${d.num_candado})` : '(⚠️ Sin candado)'}
                                    </span>
                                ))}
                            </div>
                        ) : <p style={{ fontSize: '12px', color: '#666', margin: '5px 0' }}>No requiere descargos eléctricos.</p>}
                    </div>

                    {/* Descargos Mecánicos */}
                    <div>
                        <strong style={{ fontSize: '13px', color: '#2e7d32' }}>Descargos Mecánicos ({mecanicos.length}):</strong>
                        {mecanicos.length > 0 ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                {mecanicos.map((m, i) => (
                                    <span key={i} className="skill-tag" style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', padding: '6px 12px', fontSize: '13px' }}>
                                        🔧 {m}
                                    </span>
                                ))}
                            </div>
                        ) : <p style={{ fontSize: '12px', color: '#666', margin: '5px 0' }}>No requiere descargos mecánicos.</p>}
                    </div>
                    {/* Trabajos Previos */}
                    <div>
                        <strong style={{ fontSize: '13px', color: '#000000' }}>Otros Trabajos Previos ({trabajosPrevios.length}):</strong>
                        {trabajosPrevios.length > 0 ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                {trabajosPrevios.map((tp, i) => (
                                    <span key={i} className="skill-tag" style={{ backgroundColor: '#363636', color: '#cecdcd', padding: '6px 12px', fontSize: '13px' }}>
                                        👷 {tp}
                                    </span>
                                ))}
                            </div>
                        ) : <p style={{ fontSize: '12px', color: '#666', margin: '5px 0' }}></p>}
                    </div>
                </div>
            </ExpandableCard>

            {/* 4. VALIDACIÓN CONSIGNACIÓN Y ESTADO DE CAJA */}
            <ExpandableCard title="Validación Consignación y Estado" icon="✍️">
                {!necesitaConsignacion ? (
                    <p style={{ color: '#666', fontStyle: 'italic', fontSize: '13px' }}>
                        ℹ️ No se requieren firmas de consignación ni gestión de llaves (Sin descargos LOTO activos en la HPT).
                    </p>
                ) : (
                    <>
                        {/* Cajas de llaves - Solo visibles si hay LOTO */}
                        <div className="safe-box-grid" style={{ marginBottom: '25px' }}>
                            <div className="field">
                                <label className="info-label">Nº CAJA:</label>
                                <input className="main-input" value={ptw.numero_caja || ''} disabled={isConsignacionBloqueada} onChange={e => setPtw({...ptw, numero_caja: e.target.value})} />
                            </div>
                            <div className="field">
                                <label className="info-label">CANDADOS OPERACIÓN:</label>
                                <input className="main-input" value={ptw.candado_operacion || ''} disabled={isConsignacionBloqueada} onChange={e => setPtw({...ptw, candado_operacion: e.target.value})} />
                            </div>
                            <div className="field">
                                <label className="info-label">CANDADOS EJECUTANTE:</label>
                                <input className="main-input" value={ptw.candado_ejecutante || ''} disabled={isConsignacionBloqueada} onChange={e => setPtw({...ptw, candado_ejecutante: e.target.value})} />
                            </div>
                        </div>

                        {/* Firmas */}
                        <div className="signature-row">
                            {['Jefe de Turno', 'Jefe de Trabajo'].concat(intervieneSubcontrata ? ['Resp. Contrata'] : []).map(rol => (
                                <div key={rol} className="sign-box-full">
                                    <p><strong>{rol}</strong></p>
                                    <div className="placeholder-sign">
                                        {firmasSecciones.consignacion[rol]?.firma_path ? (
                                            <img src={firmasSecciones.consignacion[rol].firma_path} style={{height:'100%'}} alt="sig"/>
                                        ) : puedeFirmar('consignacion', rol) ? (
                                            <button 
                                                className="sign-btn-small" 
                                                onClick={() => handleOpenSignature('fija', 'consignacion', null, rol)}
                                            >
                                                Firmar
                                            </button>
                                        ) : (
                                            <span style={{ fontSize: '10px', color: '#f57c00', textAlign: 'center', padding: '0 5px' }}>Rellena tus datos para firmar</span>
                                        )}
                                    </div>
                                    {renderInputNombre('consignacion', rol, false)}
                                    {firmasSecciones.consignacion[rol]?.fecha_hora && (
                                        <div className="timestamp-tag">{firmasSecciones.consignacion[rol].fecha_hora}</div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </ExpandableCard>

            {/* 5. RIESGOS */}
            <ExpandableCard title="Evaluación de Riesgos" icon="🚨">
                <div className="category-grid">
                    {categoriasRiesgo.map(cat => (
                        <div key={cat} className="cat-block">
                            <div className="cat-title">{cat}</div>
                            <div className="grid-checks-auto">
                                {catalogo.filter(i => i.categoria === cat && i.es_riesgo).map(item => (
                                    <label key={item.id_item} className={`check-item ${seleccionados.includes(item.id_item) ? 'checked-risk' : ''}`}>
                                        <input type="checkbox" disabled={isMedidasBloqueadas} checked={seleccionados.includes(item.id_item)} onChange={() => toggleItem(item.id_item)} />
                                        <span><strong>{item.codigo}</strong> - {item.descripcion}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </ExpandableCard>

            {/* 6. FIRMAS MEDIDAS */}
            <ExpandableCard 
                title="Firmas Validación de Medidas" 
                icon="✍️"
                onToggle={(state) => setFirmasMedidasOpen(state)}
            >
                <div className="signature-row">
                    {['Jefe de Trabajo', 'Recurso Preventivo'].concat(intervieneSubcontrata ? ['Resp. Contrata'] : []).map(rol => (
                        <div key={rol} className="sign-box-full">
                            <p><strong>{rol}</strong></p>
                            <div className="placeholder-sign">
                                {firmasSecciones.medidas[rol]?.firma_path ? (
                                    <img src={firmasSecciones.medidas[rol].firma_path} style={{height:'100%'}} alt="sig"/> 
                                ) : puedeFirmar('medidas', rol) ? (
                                    <button className="sign-btn-small" onClick={() => handleOpenSignature('fija', 'medidas', null, rol)}>Firmar</button>
                                ) : (
                                    <span style={{ fontSize: '10px', color: '#f57c00', textAlign: 'center', padding: '0 5px' }}>Rellena tus datos para firmar</span>
                                )}
                            </div>
                            {renderInputNombre('medidas', rol, false)}
                            {firmasSecciones.medidas[rol]?.fecha_hora && (
                                <div className="timestamp-tag">{firmasSecciones.medidas[rol].fecha_hora}</div>
                            )}
                        </div>
                    ))}
                </div>
            </ExpandableCard>

            {/* 7. MEDIDAS CORRECTORAS (Se abre al abrir Firmas) */}
            <ExpandableCard 
                title="Medidas Correctoras Aplicadas" 
                icon="🛡️"
                externalOpen={firmasMedidasOpen}
            >
                <div className="category-grid">
                    {categoriasMedida.map(cat => (
                        <div key={cat} className="cat-block">
                            <div className="cat-title">{cat}</div>
                            <div className="grid-checks-auto">
                                {catalogo.filter(i => i.categoria === cat && !i.es_riesgo).map(item => (
                                    <label key={item.id_item} className={`check-item ${seleccionados.includes(item.id_item) ? 'checked-measure' : ''}`}>
                                        <input type="checkbox" disabled={isMedidasBloqueadas} checked={seleccionados.includes(item.id_item)} onChange={() => toggleItem(item.id_item)} />
                                        <span>{item.descripcion}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </ExpandableCard>

            {/* 8. OBSERVACIONES Y RECURSO */}
            <ExpandableCard title="Descripción del Trabajo y Recursos" icon="📝">
                <div className="field relative mb-15" style={{ zIndex: mostrarDesplegableUsuarios ? 9999 : 1 }}>
                    <label className="info-label">RECURSO PREVENTIVO DESIGNADO (Buscador):</label>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                        <input 
                            type="text" 
                            className="main-input" 
                            placeholder="Buscar nombre, apellidos, rol o grupo..."
                            value={busquedaUsuarios}
                            disabled={isPtwAbiertoOCerrado}
                            onChange={(e) => {
                                buscarUsuariosServidor(e.target.value);
                                setMostrarDesplegableUsuarios(true);
                            }}
                            onFocus={() => setMostrarDesplegableUsuarios(true)}
                            onBlur={() => setTimeout(() => setMostrarDesplegableUsuarios(false), 200)}
                        />
                        
                        {mostrarDesplegableUsuarios && busquedaUsuarios.length >= 2 && (
                            <ul className="autocomplete-list">
                                {opcionesUsuarios.length > 0 ? (
                                    opcionesUsuarios.map((op, index) => (
                                        <li 
                                            key={`${op.valor}-${index}`}
                                            className="autocomplete-item"
                                            onMouseDown={() => seleccionarListaUsuarios(op)}
                                        >
                                            <strong>{op.tipo === 'GRUPO' ? '👥 Grupo:' : '👤 Usuario:'} {op.etiqueta}</strong>
                                            <br/>
                                            <span className="text-small text-muted" style={{ wordBreak: 'break-all' }}>
                                                {op.descripcion}
                                            </span>
                                        </li>
                                    ))
                                ) : (
                                    <li className="autocomplete-item">No se encontraron resultados...</li>
                                )}
                            </ul>
                        )}

                        <input 
                            className="input-solicitante"
                            placeholder="Nombres o Grupos seleccionados..."
                            value={ptw.recurso_preventivo_nombre || ''} 
                            disabled={isPtwAbiertoOCerrado}
                            onChange={e => setPtw({...ptw, recurso_preventivo_nombre: e.target.value})} 
                        />
                    </div>
                </div>

                <label className="info-label mt-15 d-flex">DESCRIPCIÓN DEL TRABAJO (HPT):</label>
                <div className="desc-text-details" style={{ backgroundColor: '#f0f4f8', borderLeftColor: '#1a237e' }}>
                    {ptw.descripcion_trabajo || 'Sin descripción'}
                </div>

                {/* INFO SUBCONTRATA Y TRABAJADORES */}
                {intervieneSubcontrata && (
                    <div style={{ marginTop: '20px', backgroundColor: '#fff', padding: '15px', borderRadius: '8px', border: '1px solid #c5d1df' }}>
                        <h4 style={{ margin: '0 0 10px 0', color: '#1a237e', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>🏢 Personal de Subcontrata</h4>
                        <p style={{ fontSize: '13px', margin: '0 0 15px 0' }}><strong>Responsable asignado:</strong> {ptw.hpt?.nombre_subcontrata || 'No asignado'}</p>
                        
                        {ptw.hpt?.trabajadores && ptw.hpt.trabajadores.length > 0 ? (
                            <div className="worker-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
                                {ptw.hpt.trabajadores.map((t, idx) => (
                                    <div key={idx} className="worker-card" style={{ backgroundColor: '#fafafa', padding: '12px', border: '1px solid #eee', display: 'flex', flexDirection: 'column' }}>
                                        <div className="worker-name" style={{ fontSize: '13px', marginBottom: '8px', color: '#1a237e' }}>
                                            👤 {t.nombre} {t.apellidos} {t.empresa && <span className='worker-enterprise'>🏢 {t.empresa}</span>}
                                        </div>
                                        <div className="worker-skill-container" style={{ flexGrow: 1 }}>
                                            {[
                                                { id: 'carretilla_elevadora', label: '🚜 C. Elev.' }, { id: 'carretilla_telescopica', label: '🔭 C. Telescópica' },
                                                { id: 'plataforma_elevadora', label: '🕹️ Pla. Elev.' }, { id: 'puente_grua', label: '🏗️ Pte Grúa' },
                                                { id: 'espacios_confinados', label: '🕳️ Confinados' }, { id: 'formacion_altura', label: '🧗 Altura' },
                                                { id: 'baja_tension', label: '⚡ B.T.' }, { id: 'alta_tension', label: '🌩️ A.T.' },
                                                { id: 'camion_pluma', label: '🚚 Camión Pluma' }, { id: 'grua', label: '🏗️ Grúa' },
                                                { id: 'recurso_preventivo', label: '🛡️ R. Prev', isSpecial: true }
                                            ].map(hab => t[hab.id] ? <span key={hab.id} className={`skill-tag ${hab.isSpecial ? 'skill-preventive' : ''}`} style={{ fontSize: '9px', padding: '3px 6px' }}>{hab.label}</span> : null)}
                                            {t.otros && t.otros.trim() !== '' && <span className="skill-tag" style={{ backgroundColor: '#e0e0e0', color: '#424242' }}>📝 {t.otros}</span>}
                                        </div>

                                        {/* FIRMA INDIVIDUAL DEL TRABAJADOR */}
                                        <div style={{ marginTop: '15px', borderTop: '1px dashed #ccc', paddingTop: '10px' }}>
                                            <p style={{ fontSize: '10px', color: '#d32f2f', fontWeight: 'bold', marginBottom: '8px', lineHeight: '1.2', textAlign: 'center' }}>
                                                ✍️ Con mi firma acepto y reconozco estar habilitado para las tareas arriba marcadas.
                                            </p>
                                            
                                            <div className="placeholder-sign" style={{ height: '70px', backgroundColor: '#fff' }}>
                                                {firmasSecciones.trabajadores?.[`worker_${idx}`]?.firma_path ? (
                                                    <img src={firmasSecciones.trabajadores[`worker_${idx}`].firma_path} style={{height:'100%'}} alt="Firma Trabajador"/>
                                                ) : (
                                                    <button 
                                                        className="sign-btn-small" 
                                                        onClick={() => handleOpenSignature('fija', 'trabajadores', null, `worker_${idx}`)}
                                                    >
                                                        Firmar
                                                    </button>
                                                )}
                                            </div>
                                            
                                            {firmasSecciones.trabajadores?.[`worker_${idx}`]?.fecha_hora && (
                                                <div className="timestamp-tag" style={{ textAlign: 'center', marginTop: '5px' }}>
                                                    {firmasSecciones.trabajadores[`worker_${idx}`].fecha_hora}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p style={{ fontSize: '12px', color: '#666', margin: '0', fontStyle: 'italic' }}>No se ha listado personal.</p>
                        )}
                    </div>
                )}
            </ExpandableCard>

            {/* --- 9. APERTURA DEL PERMISO --- */}
            <ExpandableCard title="Apertura del Permiso" icon="🔓" defaultOpen={ptw.estado === 'creado'}>
                
                {/* LOGICA DE ESTADO DE FIRMAS. Se BLOQUEA si el anterior no esta completado*/}
                {!puedeFirmarApertura && (
                    <div className="alert-lock-banner">
                        <span style={{ fontSize: '24px' }}>🚫</span>
                        <div>
                            <strong>BLOQUEO DE SEGURIDAD:</strong> <br/>
                            Para habilitar la apertura, primero deben completarse todos los nombres y firmas en el acordeón de "Firmas Validación de Medidas".
                        </div>
                    </div>
                )}

                {/* Reducimos opacidad si está bloqueado */}
                <div className="signature-grid" style={{ opacity: puedeFirmarApertura ? 1 : 0.5 }}>
                    {['Jefe Trabajo', 'Recurso Prev.'].concat(intervieneSubcontrata ? ['Resp. Contrata'] : []).concat(['Jefe de Turno']).map(rol => (
                        <div key={rol} className="sign-box-full">
                            <p style={{fontSize: '14px', marginBottom: '10px'}}><strong>{rol}</strong></p>
                            
                            <div className="placeholder-sign">
                                {firmasSecciones.apertura[rol]?.firma_path ? (
                                    <img src={firmasSecciones.apertura[rol].firma_path} style={{height:'100%'}} alt="sig"/>
                                ) : puedeFirmar('apertura', rol) ? (
                                    <button 
                                        className="sign-btn-small"
                                        onClick={() => handleOpenSignature('fija', 'apertura', null, rol)}
                                        disabled={!puedeFirmarApertura} 
                                    >
                                        Firmar Apertura
                                    </button>
                                ) : (
                                    <span style={{ fontSize: '10px', color: '#f57c00', textAlign: 'center', padding: '0 5px' }}>Rellena tus datos para firmar</span>
                                )}
                            </div>

                            {renderInputNombre('apertura', rol, !puedeFirmarApertura)}
                            {rol === 'Jefe de Turno' ? (
                                <div style={{ display: 'flex', gap: '5px' }}>
                                    <input 
                                        type="time" 
                                        placeholder="Desde" 
                                        className="mini-input-table"
                                        value={firmasSecciones.apertura[rol]?.hora_desde || ''} 
                                        onChange={e => updateFirmaData('apertura', rol, 'hora_desde', e.target.value)} 
                                        disabled={!puedeFirmarApertura}
                                    />
                                    <input 
                                        type="time" 
                                        placeholder="Hasta" 
                                        className="mini-input-table"
                                        value={firmasSecciones.apertura[rol]?.hora_hasta || ''} 
                                        onChange={e => updateFirmaData('apertura', rol, 'hora_hasta', e.target.value)} 
                                        disabled={!puedeFirmarApertura}
                                    />
                                </div>
                            ) : (
                                <input 
                                    placeholder="Teléfono" 
                                    className="mini-input-table"
                                    value={firmasSecciones.apertura[rol]?.telefono || ''} 
                                    onChange={e => updateFirmaData('apertura', rol, 'telefono', e.target.value)} 
                                    disabled={!puedeFirmarApertura}
                                />
                            )}
                            
                            {firmasSecciones.apertura[rol]?.fecha_hora && (
                                <div className="timestamp-tag">
                                    ⏱️ {firmasSecciones.apertura[rol].fecha_hora}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </ExpandableCard>

            {/* 10. RENOVACIONES */}
            <ExpandableCard title="Renovaciones de Jornada" icon="⏳">
                <button type="button" onClick={addRenovacion} className="btn-add-item">
                    + Abrir Nueva Jornada (Renovación)
                </button>
                {renovaciones.map((ren, idx) => (
                    <div key={ren.id_temp} className="renov-block">
                        <div className="renov-header">
                            <strong>FECHA:</strong> 
                            <input 
                                type="date" 
                                className="mini-input"
                                value={ren.fecha} 
                                onChange={e => {
                                    const n = [...renovaciones]; n[idx].fecha = e.target.value; setRenovaciones(n);
                                }}
                            />
                        </div>
                        <div className="signature-grid">
                            {['Jefe Trabajo', 'Recurso Prev.', 'Resp. Contrata', 'Jefe de Turno'].filter(rol => ren.firmas[rol] !== undefined).map(rol => (
                                <div key={rol} className="sign-box-full">
                                    <p><strong>{rol}</strong></p>
                                    <div className="placeholder-sign">
                                        {ren.firmas[rol].firma_path ? (
                                            <img src={ren.firmas[rol].firma_path} style={{height:'100%'}} alt="sig"/> 
                                        ) : puedeFirmar('renovacion', rol, idx) ? (
                                            <button className="sign-btn-small" onClick={() => handleOpenSignature('renovacion', 'renovacion', idx, rol)}>Firmar</button>
                                        ) : (
                                            <span style={{ fontSize: '10px', color: '#f57c00', textAlign: 'center', padding: '0 5px' }}>Rellena tus datos para firmar</span>
                                        )}
                                    </div>
                                    {renderInputNombreRenovacion(idx, rol)}

                                    {ren.firmas[rol]?.fecha_hora && (
                                        <div className="timestamp-tag" style={{ textAlign: 'center' }}>
                                            ⏱️ {ren.firmas[rol].fecha_hora}
                                        </div>
                                    )}
                                    {rol === 'Jefe de Turno' && (
                                        <div style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
                                            <input 
                                                type="time" 
                                                className="mini-input-table"
                                                value={ren.firmas[rol]?.hora_desde || ''} 
                                                onChange={e => {
                                                    const n = [...renovaciones]; n[idx].firmas[rol].hora_desde = e.target.value; setRenovaciones(n);
                                                }}
                                            />
                                            <input 
                                                type="time" 
                                                className="mini-input-table"
                                                value={ren.firmas[rol]?.hora_hasta || ''} 
                                                onChange={e => {
                                                    const n = [...renovaciones]; n[idx].firmas[rol].hora_hasta = e.target.value; setRenovaciones(n);
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </ExpandableCard>
            {/* 11. CIERRE FINAL */}
            <ExpandableCard title="Cierre y Entrega de Activo" icon="🏁">
                <div className="signature-grid">
                    {Object.keys(firmasSecciones.cierre).map(rol => (
                        <div key={rol} className="sign-box-full">
                            <p><strong>{rol}</strong></p>
                            <div className="placeholder-sign">
                                {firmasSecciones.cierre[rol]?.firma_path ? (
                                    <img src={firmasSecciones.cierre[rol].firma_path} style={{height:'100%'}} alt="cierre"/> 
                                ) : puedeFirmar('cierre', rol) ? (
                                    <button className="sign-btn-small" onClick={() => handleOpenSignature('fija', 'cierre', null, rol)}>Firmar</button>
                                ) : (
                                    <span style={{ fontSize: '10px', color: '#f57c00', textAlign: 'center', padding: '0 5px' }}>Rellena tus datos para firmar</span>
                                )}
                            </div>
                            {renderInputNombre('cierre', rol, false)}
                            {firmasSecciones.cierre[rol]?.fecha_hora && (
                                <div className="timestamp-tag">{firmasSecciones.cierre[rol].fecha_hora}</div>
                            )}
                        </div>
                    ))}
                </div>
            </ExpandableCard>

            {/* 12. OBSERVACIONES DEL PTW (Anotaciones) */}
            <div className="main-card" style={{ marginTop: '20px', borderLeft: '6px solid #1a237e' }}>
                <label className="info-label" style={{ color: '#1a237e', fontSize: '13px', borderBottom: '1px solid #ccc', paddingBottom: '8px', display: 'block' }}>
                    <span style={{ fontSize: '16px', marginRight: '5px' }}>🗒️</span> HISTORIAL DE ANOTACIONES DURANTE EL TURNO
                </label>
                
                {/* LISTA DE ANOTACIONES  */}
                <div style={{ maxHeight: '300px', overflowY: 'auto', marginTop: '15px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {anotaciones.length === 0 ? (
                        <p style={{ color: '#666', fontStyle: 'italic', fontSize: '12px', margin: 0 }}>No hay anotaciones registradas en este permiso.</p>
                    ) : (
                        anotaciones.map(an => (
                            <div key={an.id} style={{ backgroundColor: '#f0f4f8', padding: '10px', borderRadius: '6px', borderLeft: '4px solid #1a237e' }}>
                                <div style={{ fontSize: '10.5px', color: '#555', fontWeight: 'bold', marginBottom: '6px' }}>
                                    ⏱️ {an.fecha}
                                </div>
                                <div style={{ fontSize: '13px', color: '#000', whiteSpace: 'pre-wrap' }}>
                                    {an.texto}
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {/* NUEVA ANOTACIÓN */}
                {(ptw.estado !== 'cerrado' && ptw.estado !== 'anulado') && (
                    <div style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px dashed #ccc' }}>
                        <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#f57c00' }}>+ AÑADIR NUEVA ANOTACIÓN</span>
                        <textarea 
                            className="main-textarea"
                            style={{ marginTop: '8px', backgroundColor: '#fff', borderColor: '#f57c00' }}
                            rows="3" 
                            placeholder="Escribe aquí las novedades o incidencias... (Una vez guardado, no se podrá borrar ni modificar)"
                            value={nuevaAnotacion} 
                            onChange={e => setNuevaAnotacion(e.target.value)} 
                        />
                        <div style={{ textAlign: 'right', marginTop: '10px' }}>
                            <button 
                                className="btn-save" 
                                style={{ padding: '8px 16px', fontSize: '12px', backgroundColor: '#f57c00' }}
                                onClick={handleGuardarObservaciones}
                                disabled={!nuevaAnotacion.trim()}
                            >
                                📤 Guardar y Notificar
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* COMPONENTES FLOTANTES LOTO */}
            {showBloqueoModal && bloqueoActivo && (
                <BloqueoElectrico 
                    bloqueo={bloqueoActivo}
                    hpt={hptLotoVirtual} 
                    onSave={handleGuardarCandadoBloqueo}
                    onCancel={() => setShowBloqueoModal(false)}
                />
            )}

            {showDescargoModal && descargoActivo && (
                <DescargoElectrico 
                    descargo={descargoActivo}
                    hpt={hptLotoVirtual} 
                    onSave={handleGuardarCandadoDescargo}
                    onCancel={() => setShowDescargoModal(false)}
                />
            )}

            {/* FLOTANTE: El Pad para firmar con el dedo o ratón */}
            {showSignature && <SignaturePad onSave={handleSaveSignature} onCancel={() => setShowSignature(false)} />}
            
            {/* RENDERIZADO OCULTO DEL PDF (Se genera en background) */}
            <div style={{ position: 'absolute', top: '-9999px', left: '-9999px' }}>
                <PTWPdfTemplate 
                    ref={pdfRef} 
                    ptw={ptw} 
                    catalogo={catalogo} 
                    seleccionados={seleccionados}
                    firmasSecciones={firmasSecciones} 
                    renovaciones={renovaciones} 
                    bloqueos={bloqueos} 
                    descargos={descargos} 
                    mecanicos={mecanicos} 
                    trabajosPrevios={trabajosPrevios}
                    
                />
            </div>
        </div>
    );
};

export default DetailsPTWScreen;